<template>
  <b-collapse class="card collapse-client" :open="false"
              @open="changeIsOpen" @close="changeIsOpen">
    <div slot="trigger" class="card-header">
      <img class="img-client" src="@/assets/default-placeholder.png"/>
      <p class="card-header-title">
        {{detailOpportunite.annonceur}}
      </p>
      <p v-if="detailOpportunite.data.contact" class="card-header-title has-text-weight-normal">
        {{detailOpportunite.data.contact.prenom}} {{detailOpportunite.data.contact.nom}}
      </p>
      <a class="card-header-icon">
        <b-icon
          :icon="isOpen ? 'menu-down' : 'menu-up'">
        </b-icon>
      </a>
    </div>
    <div class="card-content" v-if="detailOpportunite.data.contact">
      <div class="content">
        <p class="subtitle">Informations contact :</p>
        <span>Téléphone : <strong>{{detailOpportunite.data.contact.telephone}}</strong></span><br>
        <span>Email : <strong>{{detailOpportunite.data.contact.email}}</strong></span><br>
        <br>
      </div>
    </div>
    <div class="card-content" v-else>
        <p>Aucune information contact.</p>
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: 'client',
  props: ['detailOpportunite'],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    changeIsOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
  .collapse-client {
    position: relative;
    z-index: 10;
  }

  .img-client {
    max-width: 40px;
    max-height: 40px;
  }

  .card-header {
    height: 40px;
  }

  input, .supprimerContact, .voirClient {
    margin-bottom: 10px;
  }

  .button-add-client {
    padding-left: 10px;
  }

  span, p {
    font-size: 14px;
    color: #2C3E50;
  }

  .add-client {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/detail/client.vue